import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { FormSelectOption } from '@app/src/app/shared/components/form';
import { MediaService } from '@app/src/app/shared/services/media';
import { MingaSettingsService } from '@app/src/app/store/Minga/services';

import { FORM_FIELDS, MyClassMessages } from '../../constants/tt-my-class.constants';
import { MyClassSortColumns, SettingsMenu } from '../../types/tt-my-class.types';

@Component({
  selector: 'mg-tt-settings',
  templateUrl: './tt-settings.component.html',
  styleUrls: ['./tt-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TtSettingsComponent {
  @Input() form: UntypedFormGroup;

  // Constants
  public readonly MESSAGES = MyClassMessages;
  public readonly FORM_FIELDS = FORM_FIELDS;
  public readonly SETTINGS_MENU = SettingsMenu;

  // this used to be a toggle, now it's a dropdown
  public readonly NAME_SORT_OPTIONS: FormSelectOption<MyClassSortColumns>[] = [
    { value: 'firstName', label: MyClassMessages.SETTINGS_SORT_FIRST_NAME },
    { value: 'lastName', label: MyClassMessages.SETTINGS_SORT_LAST_NAME },
    { value: 'checkinPill', label: MyClassMessages.SETTINGS_SORT_CHECKIN_PILL },
    { value: 'flextimePill', label: MyClassMessages.SETTINGS_SORT_FLEXTIME_PILL },
    { value: 'praisePill', label: MyClassMessages.SETTINGS_SORT_PRAISE_PILL },
    { value: 'guidancePill', label: MyClassMessages.SETTINGS_SORT_GUIDANCE_PILL },
  ];

  // Open menu state
  public openMenu: SettingsMenu;

  // Settings observables
  public isBehaviorEnabled$ = this._settingService.isPbisModuleEnabled();
  public isFlexTimeEnabled$ = this._settingService.isFlexTimeModuleEnabled();
  public isCheckinEnabled$ = this._settingService.isCheckinModuleEnabled();

  public isMobile$ = this._mediaService.isMobileView$;

  constructor(private _settingService: MingaSettingsService, private _mediaService: MediaService) {}

  public menuOpened(menu: SettingsMenu) {
    this.openMenu = menu;
  }

  public menuClosed(menu: SettingsMenu) {
    if (this.openMenu === menu) {
      this.openMenu = null;
    }
  }

  public sortNameChanged(event: FormSelectOption<MyClassSortColumns> | FormSelectOption<MyClassSortColumns>[]) {
    this.form.get(FORM_FIELDS.SORT_COLUMN).setValue(event);
  }
}
